/**
 * List of Micro Frontend remotes the shell can load.
 */
export enum RemoteApp {
  AIVISION = 'aivision',
}
